export const INIT = "INIT";

export const profile = {
  UPDATE_SESSION: "UPDATE_SESSION",
  LOADING_PROFILE: "LOADING_PROFILE"
};

export const models = {
  UPDATE_MODELS: "UPDATE_MODELS"
}

export const filters = {
  UPDATE_FILTERS: "UPDATE_FILTERS"
}